/*
 *   Copyright (c) 2020 BuserNet Consulting LLC
 *   All rights reserved.
 */
import { Share } from '@capacitor/share';
import { StatusBar, Style } from '@capacitor/status-bar';
import { SplashScreen } from '@capacitor/splash-screen';
import { Device } from '@capacitor/device';
import { Browser } from '@capacitor/browser';
import AppConst from '../constants/app.constant';
import CapacitorConst from '../constants/capacitor.constant';

const capacitorService = () => {
  const content = {};
  content.deviceInfo = null;
  content.isStatusBarLight = true;
  content.isCapacitorMobileApp = false;
  content.isIphone = false;
  content.isIpad = false;
  content.isIos = false;
  content.isAndroid = false;
  content.shareInformation = (title, text, url, dialogTitle) => {
    if (content.isCapacitorMobileApp) {
      Share.share({
        title,
        text,
        url,
        dialogTitle,
      }).then(() => console.log('Successful share')).catch((error) => window.console
        .log('Error sharing', error));
    }
  };
  content.changeStatusBar = () => {
    if (content.isCapacitorMobileApp) {
      StatusBar.setStyle({
        style: content.isStatusBarLight
          ? Style.Dark
          : Style.Light,
      });
      content.isStatusBarLight = !content.isStatusBarLight;
    }
  };
  content.setStatusBarBackground = () => {
    if (content.isCapacitorMobileApp && content.isAndroid) {
      StatusBar.setBackgroundColor(CapacitorConst.statusBarBackgroundColorOption);
    }
  };
  content.configureStatusBar = async () => {
    content.changeStatusBar();
    content.setStatusBarBackground();
  };
  content.hideStatusBar = () => {
    if (content.isCapacitorMobileApp) {
      StatusBar.hide();
    }
  };
  content.showStatusBar = () => {
    if (content.isCapacitorMobileApp) {
      StatusBar.show();
    }
  };
  content.hideSplashScreen = () => {
    if (content.isCapacitorMobileApp) {
      SplashScreen.hide();
    }
  };
  content.showSplashScreen = (obj) => {
    if (content.isCapacitorMobileApp) {
      if (obj) {
        SplashScreen.show(obj);
      } else {
        SplashScreen.show();
      }
    }
  };
  content.openLinkInBrowser = (urlToOpen) => Browser.open({
    url: encodeURI(urlToOpen),
  });

  content.getModeOfHtml = () => document.getElementsByTagName('html')[0].getAttribute('mode');

  content.checkIfIos = () => /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;

  content.setHeaderDefaultHeight = () => {
    let mode = content.getModeOfHtml();
    let ios = false;
    if (!mode) {
      ios = content.checkIfIos();
      if (ios) {
        mode = 'ios';
      } else {
        mode = 'md';
      }
    }
    if (mode === 'md') {
      AppConst.footerHeight = 56;
      AppConst.headerHeight = 56;
    } else {
      AppConst.footerHeight = 44;
      AppConst.headerHeight = 44;
    }
  };
  content.setIsCapacitorMobileApp = async () => {
    const deviceInfo = await Device.getInfo();
    if (deviceInfo.platform !== CapacitorConst.platform.web) {
      content.isCapacitorMobileApp = true;
    }
  };
  content.getDeviceInfo = async () => {
    if (content.deviceInfo) {
      return content.deviceInfo;
    }
    const deviceInfo = await Device.getInfo();
    content.deviceInfo = deviceInfo;
    content.setHeaderDefaultHeight();
    if (deviceInfo.platform !== CapacitorConst.platform.web) {
      content.isCapacitorMobileApp = true;
    }
    if (deviceInfo.platform === CapacitorConst.platform.ios) {
      content.isIos = true;
      // Setting model iphone or ipad
      if (deviceInfo.model === CapacitorConst.model.iPhone) {
        content.isIphone = true;
      } else if (deviceInfo.model === CapacitorConst.model.iPad) {
        content.isIpad = true;
      }
    }
    if (deviceInfo.platform === CapacitorConst.platform.android) {
      content.isAndroid = true;
    }
    return content.deviceInfo;
  };
  return content;
};
export default capacitorService();
